import React from 'react';
import { observer } from 'mobx-react';
import { invokeEventHandler } from '../../../../../helpers/ReactShortcuts';
var TreeItemImplementation = function (_a) {
    var indentation = _a.indentation, renderer = _a.renderer, item = _a.item, openedItems = _a.openedItems, onTreeItemClicked = _a.onTreeItemClicked;
    var isOpen = openedItems.includes(item)
        || (openedItems.find(function (x) { return ((x.parents.includes(x.id))); }) !== undefined);
    console.log(openedItems, openedItems.length);
    return (React.createElement("div", null,
        React.createElement("div", { onClick: function () {
                invokeEventHandler(onTreeItemClicked, item);
            } }, renderer({ item: item })),
        isOpen ? (React.createElement("div", { style: { marginLeft: '24px' } }, item.children.sort(function (a, b) { return a.name.localeCompare(b.name); }).map(function (x) { return React.createElement(TreeItemImplementation, { openedItems: openedItems, onTreeItemClicked: onTreeItemClicked, key: x.id, renderer: renderer, item: x, indentation: indentation }); }))) : null));
};
export default observer(TreeItemImplementation);
//# sourceMappingURL=TreeItemImplementation.js.map